import { render } from "./LearningHubCourse.vue?vue&type=template&id=28489ac8&scoped=true"
import script from "./LearningHubCourse.vue?vue&type=script&lang=js"
export * from "./LearningHubCourse.vue?vue&type=script&lang=js"

import "./LearningHubCourse.vue?vue&type=style&index=0&id=28489ac8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-28489ac8"]])

export default __exports__